module.exports = __webpack_public_path__ + "img/investigacion.5f3ba8c7.jpg";